var _ellipse, _path, _path2, _path3, _path4, _polygon, _rect, _rect2, _rect3, _path5, _circle, _rect4, _circle2, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon3, _polygon4, _polygon5, _polygon6, _path19, _path20, _path21, _circle3, _path22, _circle4, _path23, _rect5, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "#19 security") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.27,
    cy: 248.32,
    rx: 145.07,
    ry: 20.18,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.36,249.27s-1,3.26-3.84,3.66-3.46,3.26-.83,3.85,9.13-3.1,9.13-3.1l-.42-4.15Z",
    fill: "#3c44b1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.35,232.61s-9.19-2.47-11.22-11c0,0,14.21-2.93,14.68,11.75Z",
    fill: "#3c44b1",
    opacity: 0.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.48,231.69s-6.46-10.11-.86-19.62c0,0,10.85,6.83,6.1,19.62Z",
    fill: "#3c44b1",
    opacity: 0.73
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.13,231.69s3.34-10.72,13.58-12.79c0,0,2,6.94-6.58,12.79Z",
    fill: "#3c44b1"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "281.47 231.48 283.38 244.21 295.11 244.21 296.78 231.48 281.47 231.48",
    fill: "#24285b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149.6,
    y: 46.88,
    width: 114.13,
    height: 201.44,
    fill: "#c9c9c9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 159.04,
    y: 70.22,
    width: 94.47,
    height: 144.05,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179.49,
    y: 118.45,
    width: 54.63,
    height: 76.22,
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.75,132.74,213,121.86l10,8.84,9.75,33.05,3-1.5,2.73,6.49L234.13,171l8.12,16.62s-23,34.47-67.5,19.54l-6.5,8.13,25.5,33H149.6l.72-47.57-.72-51.4V121.82s8.82-2,12.49,3.61a15.05,15.05,0,0,1,2.16,11.25l-3.75.53,1.59,18.84,15.16,20.89,11.5,19.56,17.92-.25L223.75,190l6.1-9.28-7.6-16Z",
    opacity: 0.08
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.67,
    cy: 230.72,
    r: 11.17,
    fill: "#fff",
    opacity: 0.56
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 197.01,
    y: 54.88,
    width: 32,
    height: 4.67,
    opacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185.42,
    cy: 57.73,
    r: 5.21,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.85,129.2s-1.33,5.55-.94,9.43a2.87,2.87,0,0,0,3.15,2.56,6.35,6.35,0,0,0,5.6-4l2.42-4.68a5.12,5.12,0,0,0-1.43-5.74C139.81,124,134.48,125.78,133.85,129.2Z",
    fill: "#f4a28c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "143.99 134.76 147.09 150.19 137.62 152.54 139.17 137.57 143.99 134.76",
    fill: "#f4a28c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.12,134.93s.37-2.17,2-1.76,1.1,3.54-1.16,3.51Z",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.19,132.74l-1.89,1.94a.91.91,0,0,0,.35,1.5l2.1.73Z",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.92,140a11.56,11.56,0,0,0,2.79-2.47s1.38,5.65-3.32,7.62Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.55,121.78s-4.21,3.91.68,6.34,5.27,1.39,5.27,1.39-2.52,6.6,2.16,7.7l2.58-1s5.68-7.35,2.94-10.7C147.18,125.49,143.32,115.18,133.55,121.78Z",
    fill: "#24285b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.89,151s30.81-6.65,36.17,6.84-15.72,56-15.72,56L130,212.28S94.16,168.55,138.89,151Z",
    fill: "#3c44b1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144,169.73l10.32,5.36s-.17,22.41-15.94,37.64l-8.39-.45a26.21,26.21,0,0,1-2.14-2.88C127.15,208.19,144,169.73,144,169.73Z",
    opacity: 0.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M138.7,135.67s2.11-4.09,4-2S141.05,139.66,138.7,135.67Z",
    fill: "#f4a28c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.53,157.27,119,143.65l25.48,22.4s-2.21,30.54-19.61,46.45a19.81,19.81,0,0,1-29.33-2.61C88.45,200.5,82,184.17,86.53,157.27Z",
    fill: "#ffd200"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.34,165.08l21.51-9,16.9,14.85s-1.47,20.27-13,30.82A13.14,13.14,0,0,1,101.28,200C96.61,193.76,92.32,182.93,95.34,165.08Z",
    fill: "#fff",
    opacity: 0.57
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.33,153.09a11.38,11.38,0,0,1,13.63.43c4.3,3.33,10.35,9.81,14.35,21.59,6.77,20,21.18,21.26,38.19,6.29l4.44,5.73S191.6,223.89,163,182C150.88,164.28,153.62,156.51,158.33,153.09Z",
    fill: "#3c44b1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.33,153.09a11.38,11.38,0,0,1,13.63.43c4.3,3.33,10.35,9.81,14.35,21.59,6.77,20,21.18,21.26,38.19,6.29l4.44,5.73S191.6,223.89,163,182C150.88,164.28,153.62,156.51,158.33,153.09Z",
    fill: "#fff",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130,212.28l-12.72,10a17.19,17.19,0,0,0-5.18,20.27l3.4,7.94h6l-1.75-10.42a10.81,10.81,0,0,1,5.34-11.21h0a173.85,173.85,0,0,1,26.11-12.05l8.17-3Z",
    fill: "#24285b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "221.93 171.02 201.43 136.97 202.3 124.45 213.35 131.44 227.97 168.73 221.93 171.02",
    fill: "#ffd200"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.44 171.51 221.42 175.31 224.46 173.72 231.72 187.64 235.77 185.53 228.51 171.61 231.55 170.03 229.57 166.23 219.44 171.51",
    fill: "#ffd200"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "219.44 171.51 221.42 175.31 224.46 173.72 231.72 187.64 235.77 185.53 228.51 171.61 231.55 170.03 229.57 166.23 219.44 171.51",
    fill: "#fff",
    opacity: 0.57
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.3 124.45 224.76 168.74 227.43 167.35 213.35 131.44 202.3 124.45",
    opacity: 0.08
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.34,213.83l26.2,34.94-6.63,3.37s-21.17-27.77-40.28-33.59Z",
    fill: "#24285b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M225.58,182.79s2.77-5.67,5.13-6.26,7.49,6.88-2.57,9.57Z",
    fill: "#f4a28c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M183.73,250s2.08,2.68,4.9,2,4.41,1.8,2.17,3.3-9.64.39-9.64.39l-1.11-4Z",
    fill: "#3c44b1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.77,
    cy: 108.93,
    r: 30.67,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88,103a14.53,14.53,0,1,0-20.4,15.91l1.71,8.88,4.22-.81-1.3-6.78a14.79,14.79,0,0,0,2.11.06l1.22,6.33,4.22-.81-1.21-6.33a15.1,15.1,0,0,0,2.17-1l1.32,6.86,4.22-.81-1.74-9.07A14.5,14.5,0,0,0,88,103Zm-19.21,9.37c-2.43.47-4.83-1.4-5.36-4.18s1-5.4,3.43-5.87,4.82,1.41,5.36,4.18S71.25,111.9,68.82,112.36Zm11.75-2.26c-2.42.47-4.82-1.4-5.36-4.18s1-5.4,3.43-5.87,4.82,1.41,5.36,4.18S83,109.64,80.57,110.1Z",
    fill: "#c9c9c9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 321.52,
    cy: 118.45,
    r: 30.67,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M336.92,119.7a14.53,14.53,0,1,0-25.42,4.8L309,133.19l4.13,1.21,1.95-6.63a14.91,14.91,0,0,0,1.84,1L315.06,135l4.13,1.21L321,130a13.63,13.63,0,0,0,2.38.13l-2,6.71,4.13,1.21,2.6-8.86A14.49,14.49,0,0,0,336.92,119.7Zm-21.37-.46c-2.37-.7-3.65-3.46-2.85-6.17s3.36-4.35,5.73-3.65,3.65,3.46,2.85,6.17S317.92,119.94,315.55,119.24ZM327,122.61c-2.37-.7-3.65-3.46-2.85-6.17s3.36-4.35,5.73-3.65,3.65,3.45,2.86,6.17S329.4,123.3,327,122.61Z",
    fill: "#c9c9c9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 179.49,
    y: 85.28,
    width: 55.56,
    height: 18.97,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.09,
    cy: 94.72,
    r: 2.55,
    fill: "#c9c9c9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.01,
    cy: 94.72,
    r: 2.55,
    fill: "#c9c9c9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.34,
    cy: 94.72,
    r: 2.55,
    fill: "#c9c9c9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.26,
    cy: 94.72,
    r: 2.55,
    fill: "#c9c9c9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.88,
    cy: 94.72,
    r: 2.55,
    fill: "#c9c9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.54deb41971e01a1bd20910fcc5016326.svg";
export { ForwardRef as ReactComponent };